import React, { useState, useEffect, Suspense } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { DataGrid } from '@mui/x-data-grid'
import { fetchReportingData } from '../../actions'
import { format } from 'date-fns'
import { caseCountsColumns } from './tableColumnHeaders'

export function CaseCounts({ user }): JSX.Element | null {
  const currentDate = getFormattedDate({ date: new Date() })
  const currentDateSplit = currentDate.split('-')
  const startDate = currentDateSplit[0] + '-' + currentDateSplit[1] + '-' + '01'
  const dispatch = useDispatch()
  const reportingData = useSelector((state: RootState) => state.fetchReportingData)
  const totalCount = reportingData.total_count
  const gridPageSize = 10

  useEffect(() => {
    dispatch(
      fetchReportingData({
        user_id: user,
        start_date: "'" + startDate + "'",
        end_date: "'" + currentDate + "'",
        pageIndex: 1,
        pageSize: gridPageSize,
      }),
    )
  }, [dispatch])

  const handlePageChange = (page, details) => {
    dispatch(
      fetchReportingData({
        user_id: user,
        start_date: "'" + startDate + "'",
        end_date: "'" + currentDate + "'",
        pageIndex: page + 1,
        pageSize: gridPageSize,
      }),
    )
  }

  return (
    <>
      <DataGrid
        disableColumnSelector
        autoHeight
        loading={reportingData?.fetchInProgress}
        getRowId={(row) => row?.id}
        rowCount={totalCount}
        paginationMode="server"
        rowsPerPageOptions={[gridPageSize]}
        pageSize={gridPageSize}
        rows={
          reportingData && reportingData.data && reportingData.data.length
            ? reportingData?.data.map((item, index) => {
                return {
                  id: index + 1,
                  first_name: item.first_name + ', ' + item.last_name,
                  case_count: item.case_count,
                  date: item.date,
                }
              })
            : []
        }
        columns={caseCountsColumns}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#0d688d73',
            fontWeight: '600',
          },
          '& .MuiDataGrid-columnHeader--moving': {
            backgroundColor: 'transparent !important',
          },
        }}
        onCellClick={(params, event) => {
          event.defaultMuiPrevented = true
          if (params.field === '') {
            return
          }
        }}
        onPageChange={(page, details) => {
          handlePageChange(page, details)
        }}
      />
    </>
  )
}

function getFormattedDate({ date }) {
  return format(date, 'yyyy-MM-dd')
}
